import { useState } from "react";
import { FaTelegram, FaFacebookF, FaXTwitter, FaReddit } from "react-icons/fa6";

export const Sidebar = ({onLogout}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [earnExpanded, setEarnExpanded] = useState(true);
  const [marketExpanded, setMarketExpanded] = useState(true);
  const [advertExpanded, setAdvertExpanded] = useState(true);

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="sm:hidden fixed top-4 left-4 z-50 bg-primary text-white p-2 rounded shadow-lg"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      {/* Sidebar */}
      <aside
        className={`
            w-64  bg-gray-800 border-r border-gray-700 flex flex-col
            h-full
            sm:static sm:translate-x-0
            fixed top-0 left-0 transform transition-transform duration-300 ease-in-out
            ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
            z-40 sm:h-auto
        `}
        >
        

        {/* Logo / Title */}
        <div className="p-6 text-lg font-bold tracking-wide border-b border-gray-700 text-white">
            <a href="/dashboard" ><img src="/static/media/new_logo_without_font.d2a01c8b4f6a79d54286.png" alt="CoinZUp Logo" className="w-64 h-auto" /></a>
        </div>

      {/* Réseaux sociaux */}
      <div className="flex justify-center gap-4 p-4 border-b border-gray-700">
        <a href="https://x.com/coinzup2025" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <FaXTwitter size={18} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61576040825765" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <FaFacebookF size={18} />
            </a>
            <a href="https://t.me/coinzup2025" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <FaTelegram size={18} />
            </a>
        </div>
        
        {/* Navigation links */}
        <nav className="flex-1 px-4 py-4 text-sm overflow-y-auto">
          <a
            href="/dashboard"
            className="block py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded"
          >
            Dashboard
          </a>

          <a
            href="/blog/newcrypto"
            className="block py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-yellow-400 font-semibold"
          >
            What's new?
          </a>

          <a
            href="/leaderboard"
            className="block py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded"
          >
            Leaderboard
          </a>

          {/* Earn coinz expandable */}
          <div>
          <button
            onClick={() => setEarnExpanded(!earnExpanded)}
            className={`
              w-full text-left py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded flex justify-between items-center
              text-yellow-400 font-bold
            `}
            aria-expanded={earnExpanded}
          >
            Earn coinz
            <span className={`transform transition-transform duration-200 ${earnExpanded ? "rotate-90" : ""}`}>
              ▶
            </span>
          </button>


            {earnExpanded && (
              <div className="ml-4">
                <a
                  href="/howitworks"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                  FAQ - How it works
                </a>
                <a
                  href="/ptppage"
                  className="block py-2 px-2 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                  Pay to promote <span className="bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">HOT</span>
                </a>
                <a
                  href="draw"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded  text-sm"
                >
                  Hourly Draw
                </a>
                <a
                  href="/autosurf"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded   text-sm"
                >
                  Autosurf
                </a>

                <a
                  href="/bonus"
                  className="block py-2 px-2 hover:bg-primary hover:text-white transition rounded   text-sm"
                >
                  Bonus
                </a>
               
              </div>
            )}
          </div>


          <div>
            <button
              onClick={() => setMarketExpanded(!marketExpanded)}
              className="w-full text-left py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded flex justify-between items-center"
              aria-expanded={marketExpanded}
            >
              Options and trading
              <span className={`transform transition-transform duration-200 ${marketExpanded ? "rotate-90" : ""}`}>
                ▶
              </span>
            </button>
            {marketExpanded && (
              <div className="ml-4">
                <a
                  href="/optionholder"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                  Dividends & Holders
                </a>
                <a
                  href="/marketplace"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                  Trade options
                </a>                
              </div>
            )}

          </div>
         
                    <div>
            <button
              onClick={() => setAdvertExpanded(!advertExpanded)}
              className="w-full text-left py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded flex justify-between items-center"
              aria-expanded={advertExpanded}
            >
              Advertising
              <span className={`transform transition-transform duration-200 ${advertExpanded ? "rotate-90" : ""}`}>
                ▶
              </span>
            </button>
            {advertExpanded && (
              <div className="ml-4">
                <a
                  href="/buyads"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                  Ads for autosurf
                </a>
                <a
                  href="/#"
                  className="block py-2 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded text-sm"
                >
                Banners (coming soon)
                </a>    

                           
              </div>
            )}

          </div>
          <a
            href="/referral"
            className="block py-3 px-2 border-b border-gray-700 hover:bg-primary hover:text-white transition rounded"
          >
            Referral program
          </a>
         
        </nav>
       {/* Logout button - collé en bas */}
       <div className="p-6 border-t border-gray-700">
          <button onClick={onLogout} className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-500 text-sm font-medium">
            Logout
          </button>
        </div>
      </aside>
    </>
  );
};
